// ESM Config
const SMAX_ARTICLES = { code: "SMAX_ARTICLES", name: "smax articles" };
const SMAX_NEW_REQUEST = { code: "SMAX_NEW_REQUEST", name: "smax create new request" };
const SMAX_ESS_ARTICLE = { code: "SMAX_ESS_ARTICLE", name: "smax ess article" };
const SMAX_ESS_OFFERING = { code: "SMAX_ESS_OFFERING", name: "smax ess offering" };
const SMAX_LIVE_SUPPORT = { code: "SMAX_LIVE_SUPPORT", name: "smax live support" };
const SMAX_LOGIN = { code: "SMAX_LOGIN", name: "smax login" };
const SMAX_OPEN_EDIT_REQUEST = { code: "SMAX_OPEN_EDIT_REQUEST", name: "smax open and edit the request" };
const SMAX_SEARCH = { code: "SMAX_SEARCH", name: "smax search" };
const SMAX_SACM = { code: "SMAX_SACM", name: "smax sacm" };
const CMS_INVENTORY = { code: "CMS_INVENTORY", name: "UCMDB Inventory" };
const CMS_SEARCH_VIEW_REPORT = { code: "CMS_SEARCH_VIEW_REPORT", name: "UCMDB Search View and Report" };
const CMS_UI_LOGIN = { code: "CMS_UI_LOGIN", name: "UCMDB UI Login" };
const CMS_VIEW_MAP = { code: "CMS_VIEW_MAP", name: "UCMDB View map" };
const SMAX_TEST_SERVICE = { code: "SMAX_TEST_SERVICE", name: "SMAX SLT CALCULATION" };

export const serviceCollection = [
  [
    SMAX_ARTICLES,
    SMAX_NEW_REQUEST,
    SMAX_ESS_ARTICLE,
    SMAX_ESS_OFFERING,
    SMAX_LIVE_SUPPORT,
    SMAX_LOGIN,
    SMAX_OPEN_EDIT_REQUEST,
    SMAX_SEARCH,
    SMAX_SACM,
    SMAX_TEST_SERVICE,
    CMS_INVENTORY,
    CMS_SEARCH_VIEW_REPORT,
    CMS_UI_LOGIN,
    CMS_VIEW_MAP,
  ],
  [
    SMAX_ARTICLES,
    SMAX_NEW_REQUEST,
    SMAX_ESS_ARTICLE,
    SMAX_ESS_OFFERING,
    SMAX_LIVE_SUPPORT,
    SMAX_LOGIN,
    SMAX_OPEN_EDIT_REQUEST,
    SMAX_SEARCH,
    SMAX_SACM,
    SMAX_TEST_SERVICE,
  ]
];

export const APPMODE = "ESM";
export const FARM_ALIAS = ['us2', 'us24', 'us26', 'us42', 'us6', 'us7', 'eu3', 'eu8', 'eu18', 'eu28', 'ap10', 'jp12', 'br14', 'ca16', 'sa34', 'eu38', 'eu44', 'sg20', 'me22'];
// Add farms here when they should be selectable for planned maintenance only.
export const MAINTENANCE_ONLY_FARMS = ['us2dev', 'us30-avt-stg', 'US50', 'EU30', 'EU32', 'jp12-staging'];
export const MAINTENANCE_FARM_ALIAS = Array.from(new Set([...FARM_ALIAS, ...MAINTENANCE_ONLY_FARMS]));
export const REAL_DATA_FARMS = ['ap10', 'br14', 'ca16', 'eu8', 'eu18', 'eu28', 'eu38', 'eu44', 'jp12', 'sa34', 'sg20', 'us6', 'us24', 'us26', 'us42'];
export const ALL_GREY_FARMS = ['me22'];
export const FORCED_GREY_FARMS = FARM_ALIAS.filter((farm) => !REAL_DATA_FARMS.includes(farm));
// Map farms to specific service collection index
// Farms listed here will always use the specified service mode, ignoring URL parameter
export const FARM_SERVICE_MODE_OVERRIDE = {
  'eu44': 1,  // Force SMAX-only mode (serviceCollection[1] = no CMS services)
};
export const MODE = ['ESM', 'SMAX', 'HCMX', 'AMX'];
export const UNITLABEL = "farm";

export const userPoolId = "us-west-2_hdQ8PQGg6";
export const userPoolWebClientId = "61cb6mn9eulgfmg35c7g6g9u6k";
export const region = "us-west-2";
export const mainPageTitle = "Enterprise Service Management System Health";
export const portalPageTitle = "System Health of Service Management Automation";

export const farmGeoData = {
  "features": [
    {
      "type": "Feature",
      "properties": {
        "title": "eu8",
        "description": "Frankfurt farm"
      },
      "geometry": {
        "coordinates": [8.34, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "eu18",
        "description": "Frankfurt farm"
      },
      "geometry": {
        "coordinates": [8.34, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "eu28",
        "description": "Frankfurt farm"
      },
      "geometry": {
        "coordinates": [8.34, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "eu3",
        "description": "Frankfurt farm"
      },
      "geometry": {
        "coordinates": [8.34, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "us2",
        "description": "Oregon farm"
      },
      "geometry": {
        "coordinates": [-122.39, 45.31],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "us24",
        "description": "Oregon farm"
      },
      "geometry": {
        "coordinates": [-122.39, 45.31],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "us26",
        "description": "Oregon farm"
      },
      "geometry": {
        "coordinates": [-122.39, 45.31],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "us6",
        "description": "Oregon farm"
      },
      "geometry": {
        "coordinates": [-122.39, 45.31],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "us7",
        "description": "Oregon farm"
      },
      "geometry": {
        "coordinates": [-122.39, 45.31],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "us42",
        "description": "Oregon farm"
      },
      "geometry": {
        "coordinates": [-122.39, 45.31],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "jp12",
        "description": "Tokyo farm"
      },
      "geometry": {
        "coordinates": [139.44, 35.41],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "ap10",
        "description": "Sydney farm"
      },
      "geometry": {
        "coordinates": [151.12, -33.41],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "br14",
        "description": "São Paulo farm"
      },
      "geometry": {
        "coordinates": [-46.6334, -23.5507],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "ca16",
        "description": "Central farm"
      },
      "geometry": {
        "coordinates": [-79, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "sa34",
        "description": "Cape Town farm"
      },
      "geometry": {
        "coordinates": [18.4233, -33.9180],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "eu38",
        "description": "Frankfurt farm"
      },
      "geometry": {
        "coordinates": [8.34, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "eu44",
        "description": "Frankfurt farm"
      },
      "geometry": {
        "coordinates": [8.34, 50],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "sg20",
        "description": "Singapore farm"
      },
      "geometry": {
        "coordinates": [103.8198, 1.3521],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {
        "title": "me22",
        "description": "Middle East farm"
      },
      "geometry": {
        "coordinates": [55.5577, 25.276987],
        "type": "Point"
      }
    },
  ],
  "type": "FeatureCollection"
}

export const farmDetails = [
  {
    "name": "us2",
    "location": "Oregon",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=us2"
  },
  {
    "name": "us24",
    "location": "Oregon",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=us24"
  },
  {
    "name": "us26",
    "location": "Oregon",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=us26"
  },
  {
    "name": "us6",
    "location": "Oregon",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=us6"
  },
  {
    "name": "us7",
    "location": "Oregon",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=us7"
  },
  {
    "name": "us42",
    "location": "Oregon",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=us42"
  },
  {
    "name": "eu3",
    "location": "Frankfurt",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=eu3"
  },
  {
    "name": "eu8",
    "location": "Frankfurt",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=eu8"
  },
  {
    "name": "eu18",
    "location": "Frankfurt",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=eu18"
  },
  {
    "name": "eu28",
    "location": "Frankfurt",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=eu28"
  },
  {
    "name": "ap10",
    "location": "Sydney",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=ap10"
  },
  {
    "name": "jp12",
    "location": "Tokyo",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=jp12"
  },
  {
    "name": "br14",
    "location": "São Paulo",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=br14"
  },
  {
    "name": "ca16",
    "location": "Central",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=ca16"
  },
  {
    "name": "sa34",
    "location": "Cape Town",
    "version": "2022.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=sa34"
  },
  {
    "name": "eu38",
    "location": "Frankfurt",
    "version": "25.3.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=eu38"
  },
  {
    "name": "eu44",
    "location": "Frankfurt",
    "version": "25.3.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=eu44"
  },
  {
    "name": "sg20",
    "location": "Singapore",
    "version": "26.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=sg20"
  },
  {
    "name": "me22",
    "location": "Middle East",
    "version": "26.1",
    "url": "https://smax-health.saas.microfocus.com/dashboard/?farm=me22"
  }
]


// dev url
export const OPS_DATA_URL = "https://kjncjstlqa.execute-api.us-west-2.amazonaws.com/dev";
export const MONITOR_DATA_URL = "https://adubp7zqfa.execute-api.us-west-2.amazonaws.com/dev";

// Dev-only demo farm used to exercise hourly APM interruption indicators.
FARM_ALIAS.push('health-poc');
MAINTENANCE_FARM_ALIAS.push('health-poc');
REAL_DATA_FARMS.push('health-poc');
farmGeoData.features.push({
	type: 'Feature',
	properties: {
		title: 'health-poc',
		description: 'Synthetic demo farm (dev only)',
	},
	geometry: {
		coordinates: [-104.9876, 39.7405],
		type: 'Point',
	},
});
farmDetails.push({
	name: 'health-poc',
	location: 'Demo',
	version: 'DEMO DATA',
	url: 'https://d1v60ehtptwwyv.cloudfront.net/dashboard/?farm=health-poc',
});
// global config
export const okColor = "#1aac60";
export const warnColor = "#ffc002";
export const errorColor = "#e5004c";
export const nodataColor = "#bdbec0";
export const MAINTENANCE_STATUS = [{ label: 'NOT STARTED', color: nodataColor }, { label: 'COMPLETED', color: okColor }];
export const INCIDENT_STATUS = [{ label: 'UNRESOLVED', color: warnColor }, { label: 'RESOLVED', color: okColor }];
export const brandColor = "linear-gradient(270deg, #088CB2 0%, #146693 8.78%, #23346A 36.9%, #222E61 74.96%, #19224A 100%)";
export const DATE_PICKER_FORMAT = "YYYY-MM-DD HH:mm:ss zZ";

